import { ROUTES } from "../../constants/routes";

export const links = [
  {
    link: ROUTES.home,
    label: "Home",
    partiallyActive: false,
  },
  {
    link: "#about-us",
    label: "About Us",
    partiallyActive: true,
  },
  {
    link: "#loan-type",
    label: "Loan Type",
    partiallyActive: true,
    links: [
      { link: ROUTES.personalFinancing, label: "Personal Financing" },
      { link: ROUTES.collateralFinancing, label: "Collateral Financing" },
      { link: ROUTES.capitalInvestment, label: "Capital Investment" },
    ],
  },
  {
    link: "#choose-us",
    label: "Why Choose Us?",
    partiallyActive: true,
  },
  {
    link: "#apply",
    label: "How To Apply",
    partiallyActive: false,
  },
  {
    link: ROUTES.faq,
    label: "FAQS",
    partiallyActive: false,
  },
  {
    link: ROUTES.contactUs,
    label: "Contact Us",
    partiallyActive: false,
  },
];
